import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import { useState } from 'react'
import ReactDatePicker from 'react-datepicker'
import bookingsApi from 'services/api/bookings'

import styles from './EditBookingDialog.module.scss'

const Datepicker = ({ label, value, onChange }) => {
  return (
    <div className={styles.datepicker}>
      <div className={styles.label}>
        {label && <div className={styles.datepickerLabel}>{label}</div>}
        <ReactDatePicker
          className={styles.datepickerInput}
          selected={value}
          onChange={onChange}
        />
      </div>
    </div>
  )
}

const EditBookingDialog = ({ booking, bookingId, onClose, onSave }) => {
  const [providerConfirmationCode, setproviderConfirmationCode] = useState('')

  const [bookingDate, setBookingDate] = useState(new Date(booking.bookingDate))

  const [checkIn, setCheckIn] = useState(new Date(booking.checkIn))

  const [checkOut, setCheckOut] = useState(new Date(booking.checkOut))

  const [totalRate, setTotalRate] = useState(booking.totalRate)

  const [totalTaxesAndFees, setTotalTaxesAndFees] = useState(booking.totalTaxesAndFees)

  const [rateCode, setRateCode] = useState(booking.rateCode)

  const [roomName, setRoomName] = useState(booking.roomName)

  const [adults, setAdults] = useState(booking.adults)

  const [children, setChildren] = useState(booking.children)

  const [transactionStatus, setTransactionStatus] = useState(booking.status)

  const [guestFirstName, setGuestFirstName] = useState(booking.guestFirstName)

  const [guestLastName, setGuestLastName] = useState(booking.guestLastName)

  const [guestPhone, setGuestPhone] = useState(booking.phoneNumber)

  const [guestEmail, setGuestEmail] = useState(booking.email)

  const [guestLoyaltyId, setGuestLoyaltyId] = useState(booking.loyaltyId)

  const [isSaving, setIsSaving] = useState(false)

  const [isSavingFailed, setIsSavingFailed] = useState(false)

  const confirmationCode = booking.confirmationCode

  const [gdsConfirmationCode, setGdsConfirmationCode] = useState('')

  const [supplierConfirmationCode, setSupplierConfirmationCode] = useState('')

  function saveChanges() {
    setIsSaving(true)
    setIsSavingFailed(false)

    bookingsApi
      .edit({
        bookingId,
        confirmationCode,
        bookingDate,
        checkIn,
        checkOut,
        totalRate,
        totalTaxesAndFees,
        rateCode,
        roomName,
        adults,
        children,
        transactionStatus,
        guestFirstName,
        guestLastName,
        guestPhone,
        guestEmail,
        guestLoyaltyId
      })
      .then(() => {
        setIsSaving(false)
        onSave()
        onClose()
      })
      .catch(() => {
        setIsSaving(false)
        setIsSavingFailed(true)
      })
  }

  return (
    <ConfirmationDialog
      maxWidth={600}
      title="Edit booking"
      onClose={onClose}
      isButtonDisabled={
        !providerConfirmationCode ||
        !transactionStatus ||
        !totalRate ||
        !totalTaxesAndFees
      }
      theme="blacklist"
      positiveMessage="Save changes"
      negativeMessage="Cancel"
      onConfirm={saveChanges}
    >
      <div
        className={styles.wrapper}
        style={isSaving ? { pointerEvents: 'none', opacity: 0.5 } : {}}
      >
        {isSavingFailed && (
          <div className={styles.error}>
            <p>Something went wrong. Please try again later.</p>
          </div>
        )}
        <div className={styles.row}>
          <p className={styles.rowTitle}>Reservation</p>
          <div className={styles.rowInner}>
            <Dropdown
              label="Booking status"
              value={transactionStatus}
              onChange={e => setTransactionStatus(e.target.value)}
              defaultValue="Select"
              options={{
                Completed: 'Completed',
                Pending: 'Pending',
                Cancelled: 'Cancelled'
              }}
            />
            <Datepicker
              label="Booking date"
              value={bookingDate}
              onChange={setBookingDate}
            />
            <Datepicker label="Check-in" value={checkIn} onChange={setCheckIn} />
            <Datepicker label="Check-out" value={checkOut} onChange={setCheckOut} />
            <TextInput label="Room name" value={roomName} onChangeValue={setRoomName} />
            <TextInput
              label="Confirmation code"
              value={confirmationCode}
              disabled={true}
            />
            <TextInput
              label="GDS confirmation code (optional)"
              value={gdsConfirmationCode}
              onChange={e => setGdsConfirmationCode(e.target.value)}
            />
            <TextInput
              label="Supplier confirmation code (optional)"
              value={supplierConfirmationCode}
              onChange={e => setSupplierConfirmationCode(e.target.value)}
            />
          </div>
        </div>
        <div className={styles.row}>
          <p className={styles.rowTitle}>Price information</p>
          <div className={styles.rowInner}>
            <TextInput
              label="Total rate ($)"
              value={totalRate}
              onChangeValue={value => setTotalRate(value.replace(/[^0-9.]+/g, ''))}
              onBlur={() => setTotalRate(Number(totalRate).toFixed(2) || 0)}
            />
            <TextInput
              label="Taxes and fees ($)"
              value={totalTaxesAndFees}
              onChangeValue={value =>
                setTotalTaxesAndFees(value.replace(/[^0-9.]+/g, ''))
              }
              onBlur={() =>
                setTotalTaxesAndFees(Number(totalTaxesAndFees).toFixed(2) || 0)
              }
            />
            <TextInput label="Rate code" value={rateCode} onChangeValue={setRateCode} />
          </div>
        </div>
        <div className={styles.row}>
          <p className={styles.rowTitle}>Guest information</p>
          <div className={styles.rowInner}>
            <TextInput
              label="First name"
              value={guestFirstName}
              onChangeValue={setGuestFirstName}
            />
            <TextInput
              label="Last name"
              value={guestLastName}
              onChangeValue={setGuestLastName}
            />
            <TextInput label="Email" value={guestEmail} onChangeValue={setGuestEmail} />
            <TextInput label="Phone" value={guestPhone} onChangeValue={setGuestPhone} />
            <TextInput
              label="Loyalty #"
              value={guestLoyaltyId}
              onChangeValue={setGuestLoyaltyId}
            />
            <div className={styles.miniRow}>
              <TextInput
                label="Adults"
                type="number"
                value={adults}
                onChangeValue={setAdults}
              />
              <TextInput
                label="Children"
                type="number"
                value={children}
                onChangeValue={setChildren}
              />
            </div>
          </div>
        </div>
      </div>
    </ConfirmationDialog>
  )
}

export default EditBookingDialog
